import React, { FC } from 'react';
import { AppBar, Dialog, IconButton, Toolbar, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  opened: boolean;
  title: string;
  children?: React.ReactNode;
  onDismiss: (data: any) => void;
}

export const NgDialog: FC<Props> = ({ opened, children, title, onDismiss }) => {
  return (
    <Dialog fullScreen open={opened} onClose={() => onDismiss(null)} sx={{ zIndex: 99999 }}>
      <AppBar sx={{ position: 'relative', background: 'white' }}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => onDismiss(null)} aria-label="close">
            <CloseIcon style={{ color: 'black' }} />
          </IconButton>
          <Typography variant="h6" sx={{ marginLeft: 2, flex: 1 }} style={{ color: 'black' }}>
            { title }
          </Typography>
        </Toolbar>
      </AppBar>

      {children}
    </Dialog>
  );
};
